import { Stack } from "@samacare/design/core";
import { IcdField } from "@samacare/form";

export type DiagnosisInfoBlockProps = {
  isSubmitted?: boolean;
  isRequired?: boolean;
};

export const HorizonKrystexxaDiagnosisBlock: React.FC<
  DiagnosisInfoBlockProps
> = ({ isSubmitted = false }) => {
  return (
    <Stack direction="column" spacing={2} maxWidth={600}>
      <IcdField
        name="questionnaire.secondaryDiagnoses"
        label="Additional disease manifestation codes"
        override={{
          limit: 1,
        }}
        disabled={isSubmitted}
      />
    </Stack>
  );
};
